<svg xmlns="http://www.w3.org/2000/svg"
     width="64px" height="64px" stroke-linejoin="round"
     viewBox="0 0 64 64">
  <g fill="none" stroke="#000000" stroke-width="4">
  <path class="D4"
        d="M 62.00,56.00
           C 62.00,56.00 2.00,56.00 2.00,56.00
             2.00,56.00 32.00,7.00 32.00,7.00
             32.00,7.00 62.00,56.00 62.00,56.00 Z
           M 62.00,56.00
           C 62.00,56.00 32.00,40.00 32.00,40.00
             32.00,40.00 2.00,56.00 2.00,56.00M 32.00,7.00
           C 32.00,7.00 32.00,40.00 32.00,40.00" />
   </g>
</svg>
